export const FALLBACK_DOCS_LINK = `Go to the <a href="https://grafana.com/docs/grafana/latest/panels/transformations/?utm_source=grafana" target="_blank" rel="noreferrer">transformation documentation</a> for more general documentation.`;
